;(function ($) {
    function getCategory(availableCategories) {
        var $page = $('.page:first');
        var categoriesMap = {
            main_page:     '.page_front',
            category_page: '.page_news_category',
            news_page:     '.page_news_article'
        };

        for (var i in availableCategories) {
            if (availableCategories.hasOwnProperty(i)) {
                var category = availableCategories[i];
                if ($page.is(categoriesMap[category])) {
                    return category;
                }
            }
        }
    }

    $(function () {
        var gaAction, gaCategory = getCategory(['main_page']);
        if (!gaCategory) {
            return;
        }

        // Newest news widget
        var $newestNewsWidget = $('.page__important-stories');
        gaAction = 'newest_news_widget';
        $newestNewsWidget.find('.story-list__item').each(function(i, e) {
            var item = i+1;
            var elem = $(e);

            elem.find('.story-list__item-title a')
                .gaEvent(gaCategory, gaAction, 'title', item);
            elem.find('.story-list__item-comments a')
                .gaEvent(gaCategory, gaAction, 'comments', item);
        });

        // Main news widget
        var $mainNewsWidget = $('.page__main-story');
        gaAction = 'main_news_widget';
        $mainNewsWidget.find('a.story-list__image')
            .gaEvent(gaCategory, gaAction, 'picture');
        $mainNewsWidget.find('.story-list__item-title a')
            .gaEvent(gaCategory, gaAction, 'title');
        $mainNewsWidget.find('.story-list__item-comments a')
            .gaEvent(gaCategory, gaAction, 'comments');

        // Promo widgets
        var $rightColumnWidget = $('.page__story-list-container_minor');
        gaAction = 'promo_widget_';
        $rightColumnWidget.find('.promo-list').each(function(i, e) {
            var promoItem = i+1;
            var promoElem = $(e);

            promoElem.find('.promo-list__item').each(function(i, e) {
                var item = i+1;
                var elem = $(e);

                elem.find('.promo-list__fluid-image')
                    .gaEvent(gaCategory, gaAction+promoItem, 'picture', item);
                elem.find('.promo-list__fluid-link')
                    .gaEvent(gaCategory, gaAction+promoItem, 'title', item);
            });
        });

        // Single photoreport widget
        var $singlePhotoreportWidget = $('.inset-container_top .inset_picture-stories');
        gaAction = 'single_photoreport_widget';
        $singlePhotoreportWidget.find('.inset__title a')
            .gaEvent(gaCategory, gaAction, 'title');
        $singlePhotoreportWidget.find('.inset__content a')
            .gaEvent(gaCategory, gaAction, 'pictures');
    });

    $(function () {
        var gaAction, gaCategory = getCategory(['category_page']);
        if (!gaCategory) {
            return;
        }

        // Main news widget
        var $mainNewsWidget = $('.page__main-category-story');
        gaAction = 'main_news_widget';
        $mainNewsWidget.find('a.story-list__image')
            .gaEvent(gaCategory, gaAction, 'picture');
        $mainNewsWidget.find('.story-list__item-title a')
            .gaEvent(gaCategory, gaAction, 'title');
        $mainNewsWidget.find('.story-list__item-comments a')
            .gaEvent(gaCategory, gaAction, 'comments');
    });

    $(function () {
        var $elem, gaCategory = getCategory(['news_page']);
        if (!gaCategory) {
            return;
        }

        // news article category
        $elem = $('.story__info-category');
        $elem.gaEvent(gaCategory, 'news_category', $.trim($elem.text()));

        // search
        $elem = $('.inset__search-submit');
        $elem.gaEvent(gaCategory, 'search');

        // archive
        $elem = $('.inset__archive .button_go');
        $elem.gaEvent(gaCategory, 'archive');

        // news in right block widget
        $('.story-list__title a').each(function(i, e) {
            $(e).gaEvent(gaCategory, 'right_news', 'category', i+1);
        });
        $('.story-list__item a').each(function(i, e) {
            $(e).gaEvent(gaCategory, 'right_news', 'title', i+1);
        });

        // social share
        $('.social-share__link').each(function(i, e) {
            var $elem = $(e);
            var classes = $elem.attr('class');
            var pattern = /social-share__link_\w\w/;
            var elemClass = pattern.exec(classes);
            if (elemClass) {
                var socialNetwork = elemClass.toString().replace('social-share__link_', '');
                $elem.gaEvent(gaCategory, 'social_share', socialNetwork);
            }
        });

        //pictures
        $('.story__images_fotorama').on('fotorama:show', function(e, fotorama) {
            var imageIndex = fotorama.activeIndex + 1;
            var $elem = $('.story__image[data-image-index='+imageIndex+']');
            $elem.gaEvent(gaCategory, 'pictures', 'image', imageIndex);
            $elem.data('ga-event')._send();
        });

        // related news
        $('.story__related-item a').each(function(i, e) {
            $(e).gaEvent(gaCategory, 'related_news', 'title', i+1);
        });
    });

    $(function () {
        var gaCategory = getCategory(['category_page', 'news_page']);
        if (!gaCategory) {
            return;
        }

        // breadcrumbs
        $('.breadcrumbs li').each(function(i, e) {
            $(e).gaEvent(gaCategory, 'news_breadcrumbs', $.trim($(e).text()), i+1);
        });
    });

    $(function () {
        var gaAction, gaCategory = getCategory(['main_page', 'category_page']);
        if (!gaCategory) {
            return;
        }

        // Left column widget
        var $leftColumnWidget = $('.page__story-list-container_main');
        gaAction = 'left_column_widget';
        $leftColumnWidget.find('.story-list__item, .story-list__item_photo').each(function(i, e) {
            var item = i+1;
            var elem = $(e);

            elem.find('.story-list__item-title a')
                .gaEvent(gaCategory, gaAction, 'title', item);
            elem.find('.story-list__item-comments a')
                .gaEvent(gaCategory, gaAction, 'comments', item);
            elem.find('a.story-list__item-category')
                .gaEvent(gaCategory, gaAction, 'category', item);
            elem.find('a.story-list__image_main')
                .gaEvent(gaCategory, gaAction, 'picture', item);
            elem.find('.story-list__item-overview a')
                .gaEvent(gaCategory, gaAction, 'text', item);
            elem.find('a.ico-picture-story')
                .gaEvent(gaCategory, gaAction, 'photoreport_icon', item);
            elem.find('.story-list__images a.story-list__image')
                .gaEvent(gaCategory, gaAction, 'photoreport_picture', item);
        });

        // Right column widget
        var $rightColumnWidget = $('.page__story-list-container_minor');
        gaAction = 'right_column_widget';
        $rightColumnWidget.find('.story-list__item, .story-list__item_photo').each(function(i, e) {
            var item = i+1;
            var elem = $(e);

            elem.find('.story-list__item-title a')
                .gaEvent(gaCategory, gaAction, 'title', item);
            elem.find('.story-list__item-comments a')
                .gaEvent(gaCategory, gaAction, 'comments', item);
            elem.find('a.story-list__item-category')
                .gaEvent(gaCategory, gaAction, 'category', item);
            elem.find('a.story-list__image_main')
                .gaEvent(gaCategory, gaAction, 'picture', item);
            elem.find('.story-list__item-overview a')
                .gaEvent(gaCategory, gaAction, 'text', item);
            elem.find('a.ico-picture-story')
                .gaEvent(gaCategory, gaAction, 'photoreport_icon', item);
            elem.find('.story-list__images a.story-list__image')
                .gaEvent(gaCategory, gaAction, 'photoreport_picture', item);
        });

        // Hot news and actual news widgets
        var $hotNewsWidget = $('.page__hot-stories');
        gaAction = 'hot_news_widget';
        $hotNewsWidget.find('.inset__content_hot .story-list__item').each(function(i, e) {
            var item = i+1;
            var elem = $(e);

            elem.find('.story-list__item-title')
                .gaEvent(gaCategory, gaAction, 'title', item);
        });
        gaAction = 'actual_news_widget';
        $hotNewsWidget.find('.inset__content_actual .story-list__item').each(function(i, e) {
            var item = i+1;
            var elem = $(e);

            elem.find('.story-list__item-title')
                .gaEvent(gaCategory, gaAction, 'title', item);
        });
    });

    $(function () {
        var gaAction, gaCategory = getCategory(['main_page', 'category_page', 'news_page']);
        if (!gaCategory) {
            return;
        }

        // Category header widget
        var $categoryHeader = $('.nav_main__items');
        gaAction = 'category_header';
        $categoryHeader.find('.nav_main__item').each(function(i, e) {
            var item = i+1;
            var elem = $(e);

            elem.find('a.nav_main__item-link')
                .gaEvent(gaCategory, gaAction, $.trim(elem.text()), item);
        });

        // Top header widget
        var $topHeader = $('.header');
        gaAction = 'top_header';
        $topHeader.find('.header__logo a')
            .gaEvent(gaCategory, gaAction, 'logo');
        $topHeader.find('.header__project a')
            .gaEvent(gaCategory, gaAction, 'project');
        $topHeader.find('span.header__search-form-toggle')
            .gaEvent(gaCategory, gaAction, 'search');

        // Footer vl widget
        var $footerVl = $('.footer__nav-container_vl');
        gaAction = 'footer_vl';
        $footerVl.find('li a').each(function(i, e) {
            var item = i+1;
            var elem = $(e);

            elem.gaEvent(gaCategory, gaAction, $.trim(elem.text()), item);
        });

        // Footer news widget
        var $footerNews = $('.footer__nav-container_news');
        gaAction = 'footer_news';
        $footerNews.find('li a').each(function(i, e) {
            var item = i+1;
            var elem = $(e);

            elem.gaEvent(gaCategory, gaAction, $.trim(elem.text()), item);
        });

        // Footer info widget
        var $footerInfo = $('.footer__info');
        gaAction = 'footer_info';
        $footerInfo.find('a').each(function(i, e) {
            var item = i+1;
            var elem = $(e);

            elem.gaEvent(gaCategory, gaAction, $.trim(elem.text()), item);
        });

        // Footer social widget
        gaAction = 'footer_info';
        $footerNews.find('a.ico-social').each(function(i, e) {
            var item = i+1;
            var elem = $(e);

            elem.gaEvent(gaCategory, gaAction, (function (e) {
                if (e.is('.ico-vk')) {
                    return 'vk'
                } else if (e.is('.ico-telegram')) {
                    return 'telegram'
                } else {
                    return $.trim(e.text())
                }
            }(elem)), item);
        });
    });
}(jQuery));
